export enum AwardStatus {
  DRAFT = 'DRAFT',
  CANDIDANCY_OPEN = 'CANDIDANCY_OPEN',
  CANDIDANCY_CLOSED = 'CANDIDANCY_CLOSED',
  VOTING_OPEN = 'VOTING_OPEN',
  VOTING_CLOSED = 'VOTING_CLOSED',
  CONCLUDED = 'CONCLUDED',
}
